import { render, staticRenderFns } from "./KeywordFilters.vue?vue&type=template&id=2d04c7be"
import script from "./KeywordFilters.vue?vue&type=script&lang=js"
export * from "./KeywordFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports